import { gql } from '@apollo/client'
import { ORDER_STATUS } from '../types/Order'

export const GET_MULTIPLE_SHOPPING_CART_TOTALS = gql`
  query MultipleShoppingCartTotals($filters: DailyMonitoringInput!) {
    multipleShoppingCartTotals(filters: $filters) {
      yearMonth
      totalDeliveredGMV
      multipleShoppingCartDeliveredGMV
      multipleShoppingCartDeliveredGMVPercent
      totalDeliveredQuantiy
      multipleShoppingCartDeliveredQuantity
      multipleShoppingCartDeliveredQuantityPercent
      totalDeliveredTicketAverage
      multipleShoppingCartTicketAverage
      multipleShoppingCartTicketGrowth
      multipleShoppingCartFailedGMV
      multipleShoppingCartCancelledGMV
      multipleShoppingCartWaitingConfirmationGMV
      multipleShoppingCartConfirmedGMV
      multipleShoppingCartDeliveringGMV
      multipleShoppingCartAvailableGMV
      multipleShoppingCartFailedQuantity
      multipleShoppingCartCancelledQuantity
      multipleShoppingCartWaitingConfirmationQuantity
      multipleShoppingCartConfirmedQuantity
      multipleShoppingCartDeliveringQuantity
      multipleShoppingCartAvailableQuantity
    }
  }
`

export const GET_MULTIPLE_SHOPPING_CART_HISTORY = gql`
  query GetMultipleShoppingCartHistory($filters: JSON) {
    ordersAggs (
      filters: $filters
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                new_status: [
                  "${ORDER_STATUS.DELIVERED}",
                  "${ORDER_STATUS.CANCELLED}"
                ]
              }
            },
            {
              term: {
                isMultipleCheckout: true
              }
            }
          ]
        }
      },
      aggs: {
        statuses: {
          terms: {
            field: "new_status",
            size: 10
          },
          aggs: {
            history: {
              date_histogram: {
                field: "created_at",
                interval: "day",
                time_zone: "-03:00"
              },
              aggs: {
                gmv: {
                  sum: {
                    field: "total"
                  }
                },
                average: {
                  avg: {
                    field: "total"
                  }
                },
                count: {
                  value_count: {
                    field: "id.keyword"
                  }
                }
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_MULTIPLE_SHOPPING_CART_PAYMENT_TYPES = gql`
  query GetMultipleShoppingCartPaymentTypes($filters: JSON) {
    ordersAggs (
      filters: $filters
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                new_status: [
                  "DELIVERED"
                ]
              }
            },
            {
              term: {
                isMultipleCheckout: true
              }
            }
          ]
        }
      },
      aggs: {
        offline: {
          filter: {
            terms: {
              payment_method_keyword: [
                "TERMINAL_CREDIT_VISA",
                "TERMINAL_CREDIT_MASTERCARD",
                "TERMINAL_CREDIT_ELO",
                "TERMINAL_CREDIT_AMEX",
                "TERMINAL_CREDIT_AURA",
                "TERMINAL_CREDIT_JCB",
                "TERMINAL_CREDIT_DINERS",
                "TERMINAL_CREDIT_DISCOVER",
                "TERMINAL_CREDIT_HIPER",
                "TERMINAL_CREDIT_HIPERCARD",
                "TERMINAL_DEBIT_VISA",
                "TERMINAL_DEBIT_MASTERCARD",
                "TERMINAL_DEBIT_ELO",
                "TERMINAL_DEBIT_AMEX",
                "TERMINAL_DEBIT_AURA",
                "TERMINAL_DEBIT_JCB",
                "TERMINAL_DEBIT_DINERS",
                "TERMINAL_DEBIT_DISCOVER",
                "TERMINAL_DEBIT_HIPER",
                "TERMINAL_DEBIT_HIPERCARD",
                "MONEY"
              ]
            }
          },
          aggs: {
            gmv: {
              sum: {
                field: "total"
              }
            }
          }
        },
        online: {
          filter: {
            terms: {
              payment_method_keyword: [
                "CREDIT_VISA",
                "CREDIT_MASTERCARD",
                "CREDIT_ELO",
                "CREDIT_AMEX",
                "CREDIT_AURA",
                "CREDIT_JCB",
                "CREDIT_DINERS",
                "CREDIT_DISCOVER",
                "CREDIT_HIPER",
                "CREDIT_HIPERCARD"
              ]
            }
          },
          aggs: {
            gmv: {
              sum: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_MULTIPLE_SHOPPING_CART_PAYMENT_METHODS = gql`
  query GetMultipleShoppingCartPaymentMethods($filters: JSON) {
    ordersAggs (
      filters: $filters
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                new_status: [
                  "DELIVERED"
                ]
              }
            },
            {
              term: {
                isMultipleCheckout: true
              }
            },
            {
              terms: {
                payment_method_keyword: [
                  "TERMINAL_CREDIT_VISA",
                  "TERMINAL_CREDIT_MASTERCARD",
                  "TERMINAL_CREDIT_ELO",
                  "TERMINAL_CREDIT_AMEX",
                  "TERMINAL_CREDIT_AURA",
                  "TERMINAL_CREDIT_JCB",
                  "TERMINAL_CREDIT_DINERS",
                  "TERMINAL_CREDIT_DISCOVER",
                  "TERMINAL_CREDIT_HIPER",
                  "TERMINAL_CREDIT_HIPERCARD",
                  "TERMINAL_DEBIT_VISA",
                  "TERMINAL_DEBIT_MASTERCARD",
                  "TERMINAL_DEBIT_ELO",
                  "TERMINAL_DEBIT_AMEX",
                  "TERMINAL_DEBIT_AURA",
                  "TERMINAL_DEBIT_JCB",
                  "TERMINAL_DEBIT_DINERS",
                  "TERMINAL_DEBIT_DISCOVER",
                  "TERMINAL_DEBIT_HIPER",
                  "TERMINAL_DEBIT_HIPERCARD",
                  "MONEY"
                ]
              }
            }
          ]
        }
      },
      aggs: {
        credit: {
          filter: {
            terms: {
              payment_method_keyword: [
                "TERMINAL_CREDIT_VISA",
                "TERMINAL_CREDIT_MASTERCARD",
                "TERMINAL_CREDIT_ELO",
                "TERMINAL_CREDIT_AMEX",
                "TERMINAL_CREDIT_AURA",
                "TERMINAL_CREDIT_JCB",
                "TERMINAL_CREDIT_DINERS",
                "TERMINAL_CREDIT_DISCOVER",
                "TERMINAL_CREDIT_HIPER",
                "TERMINAL_CREDIT_HIPERCARD"
              ]
            }
          },
          aggs: {
            gmv: {
              sum: {
                field: "total"
              }
            }
          }
        },
        debit: {
          filter: {
            terms: {
              payment_method_keyword: [
                "TERMINAL_DEBIT_VISA",
                "TERMINAL_DEBIT_MASTERCARD",
                "TERMINAL_DEBIT_ELO",
                "TERMINAL_DEBIT_AMEX",
                "TERMINAL_DEBIT_AURA",
                "TERMINAL_DEBIT_JCB",
                "TERMINAL_DEBIT_DINERS",
                "TERMINAL_DEBIT_DISCOVER",
                "TERMINAL_DEBIT_HIPER",
                "TERMINAL_DEBIT_HIPERCARD"
              ]
            }
          },
          aggs: {
            gmv: {
              sum: {
                field: "total"
              }
            }
          }
        },
        money: {
          filter: {
            terms: {
              payment_method_keyword: [
                "MONEY"
              ]
            }
          },
          aggs: {
            gmv: {
              sum: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`
